import {
    CHALLENGES_RESULTS_REQUEST,
    CHALLENGES_RESULTS_SUCCESS,
    CHALLENGES_RESULTS_ERROR,
} from 'state/actions/challenges_results'

const initialState = {
    loading: false,
    loaded: false,
    errorMessage: null,
    results: {},
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CHALLENGES_RESULTS_REQUEST: {
        return {
            ...state,
            loading: true,
            errorMessage: null,
        }
    }
    case CHALLENGES_RESULTS_SUCCESS: {
        return {
            ...state,
            loading: false,
            loaded: true,
            results: action.payload.results,
        }
    }
    case CHALLENGES_RESULTS_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: true,
            errorMessage: action.payload.errorMessage,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/challenges_results.js